import React,{Component} from "react";
import AuditTable from "./table-audit/audit-table.component";
import AuditGraph from "./graph-audit/graph-layout.component";
import { AUDIT_GRAPH_TITLE, AUDIT_LEDGER, AUDIT_MODAL_TITLE, AUDIT_RULES, MODAL_CUSTOM_MESSAGE, MODAL_CUSTOM_TITLE } from "../../../../../constants/external-constants";
import DetailsModal from "../../../../common/modal/details-modal/details-modal";
import ButtonIcon from "../../../../button";
import Exception from "./modal/exception-modal";
import AuditModal from "./modal/audit-modal";
import { ConfirmationNotificationModal } from "../../../../common/modal/confirmation-modal.component";
import { CONFIRMATION_VALUE } from "../../../../../utils/constant.utils";
import { NotificationModal } from "../../../../common/modal/notification-modal.component";
import { invoiceAuditActions } from '../../../../../store/external/invoice/invoice/invoice-audit.reducer';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Loading } from "../../../../common/loading";
import { invoiceAuditRulesActions } from "../../../../../store/external/invoice/invoice/audit-table.reducer";
import Translation from '../../../../common/translation/translation.component';

class AuditLayout extends Component {
    constructor(props) {
        super(props);

        const selectedRules = AUDIT_RULES.reduce((acc, rule) => {
            acc[rule.value] = {
                checked: rule.value === AUDIT_MODAL_TITLE.CircuitNotFound,
                id: rule.id,
                key: rule.key
            };
            return acc;
        }, {});

        this.state = {
            showExceptionModal: false,
            showAuditRule: false,
            selectedRules: selectedRules,
            selectedResultRules: selectedRules,
            inputValue: "",
            showConModal: false,
            showNotif: false,
            showExceptionConModal: false,
            showExceptionNotif: false,
            auditDetailsId: 0,
            exceptionId: 0,
            exceptionStatusId: 1,
            exceptionFlag: false,
            headerTitle: "Circuit Not Found",
            exceptionData: [],
            additionalInformationValue: "",
            errorMessage: null,
            isSaving: false
        }
    }

    componentDidMount() {
        const { invoiceDetailsId, getAuditChartData, getInvoiceAuditRules } = this.props
        getAuditChartData(invoiceDetailsId);
        getInvoiceAuditRules(invoiceDetailsId, 0);
    }

    addColorsToData(data, ledgerColors) {
        return data.map((item, index) => ({
            ...item,
            fill: ledgerColors[index % ledgerColors.length].color
        }));
    }

    handleShowExceptionModal(headerName, invoiceAuditID, auditRulesExceptionId, auditRulesResultsStatusInvalidFlag, auditRulesResultsStatusId, additionalInformationValue) {
        this.setState({
            headerTitle: headerName,
            auditDetailsId: invoiceAuditID,
            exceptionId: auditRulesExceptionId,
            exceptionFlag: auditRulesResultsStatusInvalidFlag,
            exceptionStatusId: auditRulesResultsStatusId,
            showExceptionModal: true,
            additionalInformationValue: additionalInformationValue,
        });
    }

    handleShowAuditRule() {
        this.setState({ showAuditRule: true })
    }

    handleClose() {
        this.setState({ showExceptionModal: false, showAuditRule: false })
    }

    getSelectedRules(value) {
        this.setState({ selectedResultRules: value })
    }

    handlePerfomAudit() {
        this.setState({ showConModal: true, isSaving: false });
    }

    handleCloseNotif = () => {
        this.setState({ showNotif: false, showAuditRule: false, errorMessage: null });
    }

    handleConfirmationModal = async (buttonType) => {
        const { performAudit } = this.props;
        this.setState({
            isSaving: true,
        });
        if (buttonType === CONFIRMATION_VALUE.Ok) {
            //replace by the actual API
            var result = await performAudit(this.state.selectedResultRules, this.props.invoiceDetailsId);

            if (result.success) {
                this.setState(prev => ({
                    showConModal: !prev.showConModal,
                    showNotif: true,
                    errorMessage: null,
                    isSaving: false

                }));
            }
            else {
                this.setState(prev => ({
                    showConModal: !prev.showConModal,
                    errorMessage: "Error encountered while performing audit. Please try again later.",
                    showNotif: true,
                    isSaving: false
                }));
            }
        } else {
            this.setState({
                showConModal: false
            });
        }
    }
    handleExceptionConfirmationModal = async (buttonType) => {
        const { saveExceptionStatusData, invoiceDetailsId, getInvoiceAuditRules } = this.props;
        const { exceptionStatusValue, additionalInfoValue } = this.props.invoiceAuditRules;
        if (buttonType === CONFIRMATION_VALUE.Ok) {
            this.setState(prev => ({
                showExceptionConModal: !prev.showExceptionConModal,
                showExceptionModal: false,
            }));
            saveExceptionStatusData(exceptionStatusValue.ExceptionStatusID, additionalInfoValue.AdditionalInformation, invoiceDetailsId, exceptionStatusValue.AuditDetailsID);
            getInvoiceAuditRules(invoiceDetailsId, 0);
        } else {
            this.setState({
                showExceptionConModal: false
            });
        }
    }
    handleSave(e, disableExceptionSaveChange) {
        if (!disableExceptionSaveChange) {
            this.setState({ showExceptionConModal: true });
        }   
    }
    render() {
        const { showExceptionModal, showAuditRule, auditDetailsId, exceptionId, exceptionFlag, exceptionStatusId, headerTitle, additionalInformationValue } = this.state;
        const { invoiceAuditRules, invoiceDetailsId, roles, isReadAndWrite } = this.props;
        const { isInvoiceAuditRulesDetailsLoaded } = this.props.invoiceAuditRules;
        let disableExceptionSaveChange = (invoiceAuditRules.additionalInfoValue != null || invoiceAuditRules.exceptionStatusValue != null) ?
            !((exceptionStatusId.toString() != invoiceAuditRules.exceptionStatusValue.ExceptionStatusID) ||
             (additionalInformationValue != null ? additionalInformationValue != invoiceAuditRules.additionalInfoValue.AdditionalInformation :
             (invoiceAuditRules.additionalInfoValue.AdditionalInformation != null ? invoiceAuditRules.additionalInfoValue.AdditionalInformation != '' : false))) : true;
        return (
            <div className="details-container">
                <div className="audit-layout__graph">
                    {
                        invoiceAuditRules.isInvoiceAuditRulesChartContentLoaded ?
                            Object.entries(invoiceAuditRules.auditChartItems).map(([key, data], index) => {
                                const ledgerColors = AUDIT_LEDGER[key];
                                const dataWithColors = this.addColorsToData(data, ledgerColors);
                                return (
                                    <div key={index} className="audit-layout__chart-items">
                                        <AuditGraph
                                            ledgerData={dataWithColors}
                                            pieChart={dataWithColors}
                                            customHeight={300}
                                            graphTitle={AUDIT_GRAPH_TITLE[index]}
                                        />
                                    </div>
                                )
                            })
                            : <div className="audit-layout__loading"><Loading /></div>
                    }
                </div>

                {/* Audti Table     */}
                <AuditTable handleExceptionModal={this.handleShowAuditRule.bind(this)}
                    handleShowExceptionModal={this.handleShowExceptionModal.bind(this)}
                    invoiceDetailsId={invoiceDetailsId}
                    {...roles }
                />

                {/* Audit Rule Modal */}
                <DetailsModal showModal={isReadAndWrite ? showAuditRule : ''} customClassName="audit-rules-modal" handleClose={this.handleClose.bind(this)} title={"Match / Audit"} size={"xl"} isDisable={!isReadAndWrite}>
                    <AuditModal selectedRules={this.state.selectedRules} onSelectedRules={this.getSelectedRules.bind(this)} invoiceDetailsId={invoiceDetailsId} />
                    <div className="exceptional-modal__save-button">
                        <ButtonIcon onClick={() => { this.handlePerfomAudit() }} customClassName="header-option-list header-filter-button" labelName="Perform Audit" />
                    </div>
                </DetailsModal>

                {/* Exception Modal */}
                <DetailsModal showModal={showExceptionModal} customClassName="exception-modal" handleClose={this.handleClose.bind(this)} title={headerTitle} size={"xl"}>
                    <Exception invoiceDetailsId={invoiceDetailsId} auditDetailsId={auditDetailsId} exceptionId={exceptionId} exceptionFlag={exceptionFlag} exceptionStatusId={exceptionStatusId} additionalInformationValue={additionalInformationValue} />
                    <div className="exceptional-modal__save-button">
                        {(this.props.isReadAndWrite && isInvoiceAuditRulesDetailsLoaded)&&
                            <ButtonIcon onClick={(e) => { this.handleSave(e, disableExceptionSaveChange) }} customClassName="header-option-list header-filter-button" isDisable={disableExceptionSaveChange} labelName={<Translation translationKey='save_changes' />} />
                        }
                    </div>
                </DetailsModal>

                {/* Confirmation Modal For Audit Rule Modal*/}
                <ConfirmationNotificationModal
                    show={this.state.showConModal || this.state.showExceptionConModal}
                    message={this.state.showConModal ? MODAL_CUSTOM_MESSAGE.match_audit_confirmation : MODAL_CUSTOM_MESSAGE.exception_confirmation}
                    title={MODAL_CUSTOM_TITLE.Confirmation}
                    handleModal={this.state.showConModal ? this.handleConfirmationModal : this.handleExceptionConfirmationModal.bind(this)}
                    customClass={'comment-notification-modal modal-text-bold'}
                    disabled={this.state.isSaving}
                />

                <NotificationModal
                    show={this.state.showNotif}
                    title={!this.state.errorMessage ? MODAL_CUSTOM_TITLE.Notification : MODAL_CUSTOM_TITLE.Error}
                    message={this.state.errorMessage ?? MODAL_CUSTOM_MESSAGE.match_audit_notification}
                    handleModal={this.handleCloseNotif}
                    customClass={'comment-notification-modal notification-footer modal-text-bold'}
                />
            </div>
        )
    }
}

export default connect(
    state => {
        const { invoiceInvoiceAudit, invoiceAuditRules } = state;
        return {
            invoiceInvoiceAudit,
            invoiceAuditRules
        };
    },
    dispatch => bindActionCreators(
        Object.assign({}, invoiceAuditActions, invoiceAuditRulesActions),
        dispatch
    )
)(AuditLayout);